import React, { Component } from 'react';
import { ApiUrls } from '@api/apiUrls';
import { TableProps } from '@components-shared/table/types';
import Table from 'components/shared/table';
import {
  SALES_USER_TRADING_ACCOUNT_GRID_ACTIONS,
  SALES_USER_TRADING_ACCOUNT_GRID_COLUMNS,
  SALES_USER_TRADING_ACCOUNT_GRID_FILTERS_FIELDS,
} from './constants';
import { ISalesUserTradingAccountProps } from './interfaces';

export class TradingAccountList extends Component<ISalesUserTradingAccountProps> {
  constructor(props: ISalesUserTradingAccountProps) {
    super(props);
  }

  render() {
    return (
      <Table
        tableId="trading-accounts"
        columns={SALES_USER_TRADING_ACCOUNT_GRID_COLUMNS as TableProps['columns']}
        filterFields={SALES_USER_TRADING_ACCOUNT_GRID_FILTERS_FIELDS as TableProps['filterFields']}
        actions={SALES_USER_TRADING_ACCOUNT_GRID_ACTIONS as unknown as TableProps['actions']}
        api={ApiUrls.salesUserTradingAccount.grid}
        exportAPI={ApiUrls.salesUserTradingAccount.export}
        parentContext={this}
      />
    );
  }
}
